import { cx } from '../cx.js';

export interface JsonViewProps {
  value: unknown;
  /** Etichetta per le tecnologie assistive. */
  label?: string;
  className?: string;
}

/** Dettagli strutturati (es. del registro eventi) in `code`, formattati e leggibili. */
export function JsonView({ value, label = 'Dettagli', className }: JsonViewProps) {
  let testo: string;
  try {
    testo = JSON.stringify(value, null, 2) ?? 'null';
  } catch {
    testo = String(value);
  }
  return (
    <pre aria-label={label} className={cx('t-code text-[13px] leading-5 bg-surface-sunken rounded-md p-3 overflow-x-auto whitespace-pre-wrap break-words', className)}>
      {testo}
    </pre>
  );
}
